import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Globe } from 'lucide-react';

const languages = {
  en: 'English',
  de: 'Deutsch',
  uk: 'Українська'
};

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  
  // Ensure we have a valid language value, fallback to 'en' if undefined
  const currentLanguage = i18n.language && languages[i18n.language as keyof typeof languages] ? i18n.language : 'en';

  return (
    <div className="flex items-center gap-2">
      <Globe className="h-4 w-4 text-muted-foreground" />
      <Select value={currentLanguage} onValueChange={(value) => i18n.changeLanguage(value)}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder={t('common.language')} />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(languages).map(([code, name]) => (
            <SelectItem key={code} value={code}>
              {name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
} 